import { InjectionToken } from '@angular/core';

/**
 * Set optional global default values
 */
export interface ChitikaConfig {
  /** publisher id */
  publisher: string;
}

export const CHITIKA_TOKEN = new InjectionToken<ChitikaConfig>(
  'ChitikaConfig',
);
